import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';

/**
 * AgencyWelcomeStep Component
 *
 * First step of the agency onboarding wizard.
 * Introduces the agency command center concept.
 */

export function AgencyWelcomeStep() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const hasWhitelabel = user?.agency?.whitelabelEnabled === true;

  return (
    <div className="text-center">
      {/* Icon */}
      <div className="mb-6 flex justify-center">
        <div className="w-20 h-20 rounded-full bg-primary-100 flex items-center justify-center">
          <span className="material-symbols-outlined text-[44px] text-primary-600" aria-hidden="true">
            apartment
          </span>
        </div>
      </div>

      <h2 className="text-2xl font-semibold text-gray-900 mb-2">
        {t('onboarding_agency_welcome_title', { defaultValue: 'Welcome to your Brand Portfolio' })}
      </h2>
      <p className="text-gray-600 mb-8">
        {t('onboarding_agency_welcome_description', { defaultValue: 'Manage all your brands.' })}
      </p>

      <div className="space-y-3 text-left">
        <div className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-200">
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
            <span className="material-symbols-outlined text-[22px] text-primary-600" aria-hidden="true">
              business_center
            </span>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900">
              {t('onboarding_agency_welcome_feature_workspaces_label', { defaultValue: 'Brands' })}
            </p>
            <p className="text-sm text-gray-600">
              {t('onboarding_agency_welcome_feature_workspaces_desc', { defaultValue: 'Each brand gets its own space with channels, calendars, and posts.' })}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-200">
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
            <span className="material-symbols-outlined text-[22px] text-primary-600" aria-hidden="true">
              group
            </span>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900">
              {t('onboarding_agency_welcome_feature_staff_label', { defaultValue: 'Staff & brand access' })}
            </p>
            <p className="text-sm text-gray-600">
              {t('onboarding_agency_welcome_feature_staff_desc', { defaultValue: 'Enter any brand in one click to manage its content on their behalf.' })}
            </p>
          </div>
        </div>

        {hasWhitelabel && (
          <div className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-200">
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
              <span className="material-symbols-outlined text-[22px] text-primary-600" aria-hidden="true">
                palette
              </span>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">
                {t('onboarding_agency_welcome_feature_branding_label', { defaultValue: 'Atelier Mode' })}
              </p>
              <p className="text-sm text-gray-600">
                {t('onboarding_agency_welcome_feature_branding_desc', { defaultValue: 'Apply your Brand Portfolio logo, colors, and fonts across the entire platform.' })}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
